import React, { forwardRef } from 'react';

import FormControlLabel from '@mui/material/FormControlLabel';
import MuiCheckbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import FormGroup from '@mui/material/FormGroup';

export const Checkbox = forwardRef(({ name, value, label, onChange, ...props }, ref) => {
  return (
    <FormGroup row>
      <FormControlLabel
        control={
          <MuiCheckbox
            inputRef={ref}
            name={name}
            checked={value}
            // this is needed to make the checkbox work with react-hook-form
            onChange={event => onChange?.(event.target.checked)}
            onClick={event => event.stopPropagation()}
            color="primary"
            {...props}
            size="small"
          />
        }
        label={
          <Typography variant="body2" color="textPrimary">
            {label}
          </Typography>
        }
        labelPlacement="end"
      />
    </FormGroup>
  );
});

export default Checkbox;
